document.addEventListener("DOMContentLoaded", function () {
    let collectionSliders = [];
    let slidesCountDesktop = document.querySelector(".collection-slider").dataset.slidesCountDesktop;
    let slidesCountMobile = document.querySelector(".collection-slider").dataset.slidesCountMobile;
  
    function initSwiper() {
      // Get all collection sliders
      const sliders = document.querySelectorAll(".collection-slider");
      
      sliders.forEach((slider, index) => {
        const swiper = new Swiper(slider, {
          direction: "horizontal",
          spaceBetween: 15,
          slidesPerView: slidesCountMobile,
          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev"),
          },
          a11y: {
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
          },
          keyboard: {
            enabled: true,
          },
          breakpoints: {
            989: {
              slidesPerView: slidesCountDesktop,
            },
          },
        });
        
        collectionSliders.push(swiper);
      });
    }
  
    // Function to destroy Swiper instances
    function destroySwiper() {
      collectionSliders.forEach(swiper => {
        if (swiper) {
          swiper.destroy(true, true);
        }
      });
      collectionSliders = [];
    }
  
    // Initialize on load
    initSwiper();
  
    // Handle resize events
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        destroySwiper();
        initSwiper();
      }, 250); // Debounce resize events
    });
  });